// ANGULAR
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
// SERVICES
import { AlertService } from '@services/alert.service';
import { GlobalService } from '@services/global.service';
import { TokensService } from '@api-requests-services/tokens.service';
// MODELS
import { TokensCfg } from '@models/tokens.model';

export enum Views {
  Home = 'home',
  Configuration = 'configuration',
  EditConfiguration = 'editConfiguration',
}

@Component({
  selector: 'app-tokens',
  templateUrl: './tokens.component.html',
  styleUrl: './tokens.component.css',
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class TokensComponent implements OnInit {
  newPassword: string;
  tokensCfg: TokensCfg | null = null;
  uneditedTokenUsuarioMinutes: number;
  uneditedTokenM2MHours: number;
  uneditedTokenClienteHours: number;
  uneditedRefreshTokenUsuarioDays: number;
  // Control de contenido html
  views = Views;
  showPassword: boolean = false;
  currentView: string = Views.Home;

  constructor(
    private alertService: AlertService,
    public globalService: GlobalService,
    private tokensService: TokensService,
    private title: Title
  ) {
    this.title.setTitle('Oráculo - Tokens');
  }

  ngOnInit(): void {
    this.getTokensCfg();
  }

  selectView(view: string, resetTokensCfg?: boolean): void {
    this.currentView = view;

    switch (this.currentView) {
      case Views.Home:
        this.showPassword = false;;
        break

      case Views.Configuration:
        this.showPassword = false;
        if (resetTokensCfg && !!this.tokensCfg) {
          this.tokensCfg.settings.tokenUsuarioMinutes = this.uneditedTokenUsuarioMinutes;
          this.tokensCfg.settings.tokenM2MHours = this.uneditedTokenM2MHours;
          this.tokensCfg.settings.tokenClienteHours = this.uneditedTokenClienteHours;
          this.tokensCfg.settings.refreshTokenUsuarioDays = this.uneditedRefreshTokenUsuarioDays;
        }
        break

      case Views.EditConfiguration:
        this.showPassword = false;
        break
    }
  }

  changeShowPassword(): void { if (!!this.tokensCfg && this.tokensCfg.tokenPassword !== '') { this.showPassword = !this.showPassword; } }

  getTokensCfg(): void {
    this.tokensService.getTokensCfg().subscribe(
      tokensCfg => {
        if (tokensCfg) {
          // console.log('Tokens Cfg: ', tokensCfg);
          this.tokensCfg = tokensCfg;
          this.uneditedTokenUsuarioMinutes = tokensCfg.settings.tokenUsuarioMinutes;
          this.uneditedTokenM2MHours = tokensCfg.settings.tokenM2MHours;
          this.uneditedTokenClienteHours = tokensCfg.settings.tokenClienteHours;
          this.uneditedRefreshTokenUsuarioDays = tokensCfg.settings.refreshTokenUsuarioDays;
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting Tokens Configuration:', error);
        }
      }
    );
  }

  editConfiguration(): void {
    this.alertService.showConfirmAlert(
      `Editar configuración`,
      `¿Seguro que quieres editar la configuración de los Tokens?`
    ).then((result) => {
      if (result.isConfirmed && !!this.tokensCfg) {
        this.tokensService.postTokensCfg(this.tokensCfg.settings).subscribe(
          () => {
            this.alertService.showAutoCloseMessage(`¡Configuración editada!`, ``, "success", 1200);
            this.selectView(Views.Home);
          },
          error => {
            if (error.error === this.globalService.editModeDisabledMsg) {
              this.alertService.swalEditingNotEnabled();
            } else {
              this.alertService.swalError(error.error);
              console.error('Error editing Tokens Settings:', error);
            }
          }
        );
      }
    });
  }

  rotatePassword(): void {
    this.alertService.showConfirmAlert(
      `Rotar contraseña`,
      `¿Seguro que quieres rotar la contraseña de configuración de Tokens"?`
    ).then((result) => {
      if (result.isConfirmed) {
        this.tokensService.postRotateTokensCfgPassword().subscribe(
          tokensCfg => {
            if (tokensCfg) {
              // console.log('Rotate Tokens Cfg Password: ', tokensCfg);
              this.tokensCfg = tokensCfg;
              this.uneditedTokenUsuarioMinutes = tokensCfg.settings.tokenUsuarioMinutes;
              this.uneditedTokenM2MHours = tokensCfg.settings.tokenM2MHours;
              this.uneditedTokenClienteHours = tokensCfg.settings.tokenClienteHours;
              this.uneditedRefreshTokenUsuarioDays = tokensCfg.settings.refreshTokenUsuarioDays;
              this.alertService.showAutoCloseMessage(`¡Contraseñas de configuración de Tokens cambiada!`, ``, "success", 1500);
            }
          },
          error => {
            if (error.error === this.globalService.editModeDisabledMsg) {
              this.alertService.swalEditingNotEnabled();
            } else {
              this.alertService.swalError(error.error);
              console.error('Error Rotating Tokens Configuration Password:', error);
            }
          }
        );
      }
    });
  }

  revokePassword(): void {
    this.alertService.showConfirmAlert(
      `Revocar contraseña antigua`,
      `¿Seguro que quieres revocar la contraseña antigua de configuración de Tokens"?`
    ).then((result) => {
      if (result.isConfirmed) {
        this.tokensService.postRevokeTokensCfgOldPassword().subscribe(
          () => {
            if (!!this.tokensCfg) {
              this.tokensCfg.tokenPasswordOld = undefined;
              this.tokensCfg.tokenPasswordOldId = undefined;
            }
            this.alertService.showAutoCloseMessage(`¡Contraseñas antigua de configuración de Tokens revocada!`, ``, "success", 1500);
          },
          error => {
            if (error.error === this.globalService.editModeDisabledMsg) {
              this.alertService.swalEditingNotEnabled();
            } else {
              this.alertService.swalError(error.error);
              console.error('Error getting Tokens Configuration:', error);
            }
          }
        );
      }
    });
  }
}